/* eslint-disable jsx-a11y/label-has-for */

// node modules
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { fieldPropTypes } from 'redux-form';
import MuiSelect from '@material-ui/core/Select';
import MuiMenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

// assets
import CssField from '../Field.scss';

function Select(props) {
  const {
    input,
    label,
    meta: { form },
    options,
    initialValue,
    className,
  } = props;
  const { value, onChange, ...inputProps } = input;
  const id = `${form}-${input.name}`;

  useStyles(CssField);

  return (
    <FormControl fullWidth className={className}>
      <InputLabel shrink id={`${id}-label`}>
        {label}
      </InputLabel>

      <MuiSelect
        id={id}
        labelId={`${id}-label`}
        onChange={onChange}
        value={value || initialValue}
        inputProps={inputProps}
        IconComponent={ExpandMoreIcon}
        disableUnderline
        MenuProps={{
          style: { zIndex: 1500, position: 'fixed', inset: 0 }, // 1500 puts it above the add collection modal
        }}
        SelectDisplayProps={{
          style: { display: 'flex', alignItems: 'center' },
        }}
      >
        {options.map(option => (
          <MuiMenuItem className="field__select__item" key={option.value} value={option.value}>
            {option.Icon ? (
              <ListItemIcon>
                <option.Icon fontSize="large" color="primary" />
              </ListItemIcon>
            ) : null}
            <ListItemText secondary={option.secondary}>{option.label}</ListItemText>
          </MuiMenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  );
}

Select.propTypes = {
  ...fieldPropTypes,
};

export default Select;
